import './App.css';
import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import { motion } from "framer-motion";
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Paper from '@mui/material/Paper';
import { Box, Heading, Center, Flex, Circle, Button } from "@chakra-ui/react";
import VercelBanner from './components/VercelBanner';

// Extracted LoginForm component
const LoginForm = ({ email, setEmail, pincode, setPincode, handleChange, filtered }) => (
  <Box>
    <FormControl sx={{ m: 0, width: '19em' }} variant="outlined">
      <OutlinedInput
        value={filtered(email)}
        onChange={handleChange('mailPrefix')}
        endAdornment={<InputAdornment position="end">@kth.se</InputAdornment>}
        placeholder='Din KTH-mail'
        inputProps={{ 'aria-label': 'mailPrefix', maxLength: 10 }}
      />
    </FormControl>
    <FormControl sx={{ m: 0, width: '19em', mt: '1em' }} variant="outlined">
      <OutlinedInput
        type="password"
        value={pincode}
        onChange={(e) => {
          const value = e.target.value;
          // allow only numbers and limit to 3 digits
          if (/^\d{0,3}$/.test(value)) {
            setPincode(value);
          }
        }}
        placeholder="Välj en 3-siffrig pinkod"
        inputProps={{ maxLength: 3, pattern: "[0-9]{3}" }}
        aria-label="pincode"
      />
    </FormControl>
  </Box>
);

function App() {
  const [values, setValues] = useState({ mailPrefix: '' });
  const [pincode, setPincode] = useState('');

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const filtered = (input) => String(input).toLowerCase();

  // Combine email prefix and pincode into a string "emailPrefix:pincode"
  // The email is converted to lower case and only the part before "@" is used,
  // ensuring you can split the QR code string by ":" in your database.
  const filter_for_qr_code = (mail, pincode) => {
    let filteredMail = String(mail).toLowerCase();
    if (mail.includes("@")) {
      filteredMail = filteredMail.split("@")[0];
    }
    return `${filteredMail};${pincode}`;
  };

  return (
    <div className="App">
      <Center>
        <Box maxW="25em">
          <Flex flexDir="column" align="center" mb="1em">
            <Center pt="0.3em">
              <img src="/favicon.svg" alt="Logo" style={{ width: "15vh", height: "15vh" }} />
            </Center>
            <Heading as="h2" mt="1em" textAlign="center" size="3xl">
              Fyll i din KTH-mail och välj en slumpmässig tresiffrig pinkod<br /><br />
              Skanna QR-koden vid incheckning
            </Heading>
          </Flex>
          <LoginForm 
            email={values.mailPrefix} 
            setEmail={(val) => setValues({ ...values, mailPrefix: val })}
            pincode={pincode} 
            setPincode={setPincode} 
            handleChange={handleChange} 
            filtered={filtered}
          />
          <Center>
          <p style={{ fontSize: "1.2em"}}>
            <h4>Inga personuppgifter sparas!</h4>
            </p>
          </Center>
          <Paper elevation={0} style={{ padding:"0", marginTop:"0" }}>
            <Center>
              <QRCode size="270" value={filter_for_qr_code(values.mailPrefix, pincode)} />
            </Center>
          </Paper>
          <Center mt="1.5em">
            <Button
              as="a"
              href="https://demokrati.iare.se"
              target="_blank"
              rel="noopener noreferrer"
              bg="#7C5A3E"
              color="white"
              size="xl"
              width="270px"
              height="60px"
              fontSize="2xl"
              fontWeight="bold"
              borderRadius="4px"
              _hover={{ bg: "#8d6b4e" }}
              _active={{ bg: "#6b4a35" }}
            >
              demokrati
            </Button>
          </Center>
          <Center mt="1em">
            <p style={{ fontSize: "0.8em", color:"#333333" }}>
              Utvecklad av Oliver Midbrink<br/>
            </p>
          </Center>
        </Box>
      </Center>
    </div>
  );
}

export default App;
